/**
 * Komponente ´Form´
 */

import {extend} from '../../utils/index';

import SelectorEngine from '../../dom/selector-engine';
import Manipulator from "../../dom/manipulator";
import EventHandler from "../../dom/event-handler";

import CheckGroupRequired   from './tools/check-group-required';
import ClearableField       from './tools/clearable-field';
import NativeFormValidation from './tools/native-form-validation';

// -------
// Private
// -------

const NAME      = 'form';
const DATA_KEY  = `ifab.${NAME}`;
// const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY   = `.data-api`;

const DEFAULTS = {
	checkGroupRequired  : {},
	clearableField      : {},
	nativeFormValidation: {}
};

// ------
// Public
// ------

/**
 * Initialisierungen ´Check group required´.
 *
 * @param {HTMLElement} element
 * @param {Object} [o={}]
 * @returns {CheckGroupRequired}
 */
const checkGroupRequired = (element, o = {}) => {
	const _o = extend({}, DEFAULTS.checkGroupRequired, o);

	return new CheckGroupRequired(element, _o);
};

/**
 * Initialisierungen ´Clearable field´.
 *
 * @param {HTMLElement} element
 * @param {Object} [o={}]
 * @returns {ClearableField}
 */
const clearableField = (element, o = {}) => {
	const _o = extend({}, DEFAULTS.clearableField, o);

	return new ClearableField(element, _o);
};

/**
 * Initialisierungen ´Native form validation´.
 *
 * @param {HTMLElement} element
 * @param {Object} [o={}]
 * @returns {NativeFormValidation}
 */
const nativeFormValidation = (element, o = {}) => {
	const _o = extend({}, DEFAULTS.nativeFormValidation, o);

	return new NativeFormValidation(element, _o);
};

/**
 * Initialisierungen ´Form Reset´.
 *
 * @param {HTMLElement} element
 * @returns {NativeFormValidation}
 */
const resetForm = (element) => {
	if(!element || element.tagName.toLowerCase() !== 'form') {
		return false;
	}

	const btnDeleteFilter = SelectorEngine.findOne('#btn_delete_filter', element);

	if(btnDeleteFilter) {
		btnDeleteFilter.click();

	} else {
		const selectFields = SelectorEngine.find('select.form-select', element);
		const inputFields = SelectorEngine.find('input.form-control', element);

		if(!selectFields.length && !inputFields.length) {
			return false;
		}

		element.reset();

		for(const input of inputFields) {
			input.value = null;
			input.setAttribute('value','');
		}

		for(const select of selectFields) {
			select.selectedIndex = 0;
		}

		setTimeout(function() {
			element.submit();
		}, 500);
	}
};

/**
 * Initialisierung.
 * Standardinitialisierungen von Form tools etc..
 *
 * @param {Object} [o={}]
 */
const init = (o = {}) => {
	const _o       = extend({}, DEFAULTS, o);
	const affected = {};

	//
	// Checkbox-, Radiogruppen (multiple & required) initialisieren
	//

	const reqCheckGroups = SelectorEngine.find('[data-check-group-required]');

	if (reqCheckGroups.length) {
		affected['requiredCheckGroups'] = [];

		for (const group of reqCheckGroups) {
			affected['requiredCheckGroups'].push(checkGroupRequired(group, _o.checkGroupRequired));
		}
	}

	//
	// Formulare initialisieren
	//

	const forms = SelectorEngine.find('form[novalidate]');

	if (forms.length) {
		affected['formNoValidate'] = [];

		for (const element of forms) {
			affected['formNoValidate'].push(new NativeFormValidation(element, _o.nativeFormValidation));
		}
	}

	//
	// Clearable fields
	//

	const clearableFields = SelectorEngine.find('input[data-clearable]');

	if (clearableFields.length) {
		affected['clearableField'] = [];

		for (const element of clearableFields) {
			affected['clearableField'].push(clearableField(element, _o.clearableField));
		}
	}

	//
	// Reset Form Filter
	//

	const resetFormButtons = SelectorEngine.find('[data-form-reset]');

	if(resetFormButtons.length) {
		for(const element of resetFormButtons) {
			const form = SelectorEngine.findOne(Manipulator.getDataAttribute(element, 'form-reset'));

			if(form) {
				EventHandler.on(element, 'click', (event) => {
					resetForm(form);
				});
			}
		}
	}

	return affected;
};

// Export
export default {
	init                : init,
	checkGroupRequired  : checkGroupRequired,
	clearableField      : clearableField,
	nativeFormValidation: nativeFormValidation
};
